import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

export default function MainLayout() {
  const { pathname } = useLocation();
  return (
    <>
      <div
        className={
          "wrapper " +
          (pathname.includes("admin") || pathname.includes("office-update")
            ? " fullWidth "
            : "")
        }
      >
        {!pathname.includes("admin") && !pathname.includes("office-update") && (
          <Sidebar />
        )}
        {!pathname.includes("admin") && !pathname.includes("office-update") && (
          <Header />
        )}
        <Outlet />
      </div>
    </>
  );
}
